import { Link } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import useDocumentTitle from "../../hooks/useDocumentTitle";

const ChooseUserPage = () => {
	useDocumentTitle("Επιλέξτε χρήστη");

	return (
		<MainContainer>
			<div className="col-lg-12">
				<Link to="/ticket-office/confirmation" className="btn btn-back mb-4">
					<svg className="govgr-svg-icon--caret govgr-svg-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
						<path d="M18,22V2L6,12L18,22z"></path>
					</svg>
					Πίσω
				</Link>
				<h1 className="mb-4">Eπιλέξτε χρήστη</h1>
				<div className="row">
					<div className="col-md-4 mb-3">
						<div
							className="action-card-link btn w-100 d-flex justify-content-center text-white"
							role="button"
							aria-disabled="true"
							aria-label="Αλλοδαπός Φίλαθλος, Αλλοδαπός πολίτης που δεν έχει κάνει αυθεντικοποίηση του εγγράφου πιστοποίησής του μέσω Gov.gr Wallet, Η επιλογή δεν είναι ακόμη διαθέσιμη."
							tabIndex={0}
							style={{ minHeight: 280, cursor: "not-allowed", background: "gray", borderColor: "gray" }}
						>
							<span className="my-auto" aria-hidden="true">
								<h2>Αλλοδαπός Φίλαθλος</h2>
								<p className="white mb-0">
									Αλλοδαπός πολίτης που δεν έχει κάνει αυθεντικοποίηση του εγγράφου πιστοποίησής του μέσω Gov.gr Wallet.
								</p>
							</span>
						</div>
					</div>
					<div className="col-md-4">
						<Link
							to="/ticket-office/ticket-info?user=over-67"
							className="action-card-link btn btn-primary w-100 d-flex justify-content-center"
						>
							<span className="my-auto">
								<h2>Ημεδαπός Φίλαθλος άνω των 67 ετών</h2>
								<p className="white">Ημεδαπός Φίλαθλος ηλικίας άνω των 67. Απαιτείται εκτύπωση του εισιτηρίου.</p>
							</span>
						</Link>
					</div>
					<div className="col-md-4">
						<Link
							to="/ticket-office/transfer-events"
							className="action-card-link btn btn-primary w-100 d-flex justify-content-center"
						>
							<span className="my-auto">
								<h2>Διαχείριση Μεταβιβάσεων</h2>
								<p className="white">Καθορισμός μεταβιβάσεων εισιτηρίων σε τρίτους. Ρυθμίσεις για τη χρήση τους.</p>
							</span>
						</Link>
					</div>
				</div>
			</div>
		</MainContainer>
	);
};

export default ChooseUserPage;
